import { render } from "./LeaveApprove.vue?vue&type=template&id=4f13cc46"
import script from "./LeaveApprove.vue?vue&type=script&lang=js"
export * from "./LeaveApprove.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\ekk-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__